export default __webpack_public_path__ + "static/media/skovstykket-tenancy-09.117f0fe5.jpg";